import React from "react"
import "./banner.sass"
import Button from "../../components/button"
import LoginButton from "../../components/loginBtn"
import { showDriverForm } from "../../components/forms"
import { defaultIntl, signupLink, loginLink } from "../../utils"

export default ({ intl = defaultIntl }) => {
  const signUpLink = signupLink(intl.locale)
  const loginlink = loginLink(intl.locale)
  return (
    <div className="driver-banner">
      <div className="banner--body">
        <div className="container">
          <div className="columns is-vcentered">
            <div className="column">
              <div className="text-content">
                <h1>
                  <pre>{intl.formatMessage({ id: "driver.banner.title" })}</pre>
                </h1>
                <p>{intl.formatMessage({ id: "driver.banner.desc" })}</p>
                <div className="btn-wrapper">
                  {/* <Button onClick={() => showDriverForm({ intl })}>{intl.formatMessage({ id: "driver.banner.btn" })}</Button> */}
                  <Button to={`${signUpLink}`}>{intl.formatMessage({ id: "driver.banner.btn" })}</Button>
                  <LoginButton intl={intl} to={loginlink} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
